import Image from "next/image";
import { useRef } from "react";
import { useInView } from "framer-motion";
import style from "./StyleExamples.module.scss";
import GreenFigure from "../../../public/remove_back/avatar/green_vector.svg";
import PurpleFigure from "../../../public/remove_back/magic_bg/blue_gallery.svg";

function StyleExamples({ dictionary, styleExamplesData }) {
	const { title, description, items } = styleExamplesData;
	const containerRef = useRef(null);
	const isInView = useInView(containerRef, {
		amount: 0.8,
		once: true,
	});

	return (
		<section className={style.block} ref={containerRef}>
			<PurpleFigure className={`${style.figure} ${style.purple}`} />
			<GreenFigure className={`${style.figure} ${style.green}`} />
			<div className={style.text}>
				<h2 className={style.title}>{dictionary[title] || title}</h2>
				<p className={style.description}>{dictionary[description] || description}</p>
			</div>
			<div className={style.container}>
				{items.map((item) => (
					<div key={item.id} className={`${style.item} ${item.animation ? style.start : ""} ${isInView ? style.finish : ""}`}>
						<div className={style["image-box"]}>
							<Image loading="lazy" src={item.src} width={312} height={312} alt={item.altName} style={{ objectFit: "contain", maxWidth: "100%", height: "auto" }} />
						</div>
					</div>
				))}
			</div>
		</section>
	);
}

export default StyleExamples;
